import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { spiceroad } from '..';

export interface OTPdataProps {
  loanId: string;
  paymentAmount: number;
  paymentDate: string;
  paymentId: number;
  success: boolean;
}
export interface postOTPProps {
  OTPdata: any;
  triggerOTP: any;
  postOTPerror: boolean;
  posting: boolean;
  mutation: UseMutationResult<any, Error, postOTPReq>;
}
export interface postOTPReq {
  email: string;
  paymentDate: string | Date;
  loanId: string;
  paymentAmount: number;
}

export function postOTP(): postOTPProps {
  const mutation = useMutation({
    mutationFn: (arg: postOTPReq) =>
      spiceroad.post('/v1/otp', arg).then((res) => res.data),
    mutationKey: ['postOTP'],
  });

  return {
    OTPdata: mutation.data,
    triggerOTP: mutation.mutateAsync,
    postOTPerror: Boolean(mutation.error),
    posting: mutation.isPending,
    mutation,
  };
}

export default postOTP;
